import * as React from "react"

const FullscreenOn = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M1.598 9.009a.5.5 0 0 1 .256.137l5 5a.502.502 0 0 1-.076.77A.5.5 0 0 1 6.5 15h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .598-.491Zm12.804 0A.5.5 0 0 1 15 9.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.354-.854l5-5a.5.5 0 0 1 .256-.136ZM6.5 1a.5.5 0 0 1 .354.854l-5 5A.5.5 0 0 1 1 6.5v-5a.5.5 0 0 1 .5-.5h5Zm8 0a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.854.354l-5-5A.5.5 0 0 1 9.5 1h5Z" />
  </svg>
)

export default FullscreenOn
